import { CustomUseInfiniteQueryOptions } from '../types';
import { getNextPageParam, getPreviousPageParam } from '../utils';
import { ApiInstance, Markets, MarketsParams } from '@/libs/sdk/api';
import { useInfiniteQuery, keepPreviousData } from '@tanstack/react-query';

export const useMarkets = (
  api: ApiInstance,
  searchParams: MarketsParams,
  options?: CustomUseInfiniteQueryOptions<Markets>
) => {
  const { page = 1, pageSize = 10 } = searchParams || {};
  const { queryKey, enabled = true, ...rest } = options || {};
  return useInfiniteQuery({
    ...rest,
    enabled,
    queryKey: [queryKey, 'Markets', searchParams],
    initialPageParam: { page, pageSize },
    queryFn: async ({ pageParam }) => {
      const { data } = await api.market.getMarkets({ ...searchParams!, ...pageParam });
      return { ...data, ...pageParam };
    },
    placeholderData: keepPreviousData,
    getPreviousPageParam,
    getNextPageParam: lastPage => getNextPageParam({ ...lastPage, total: lastPage.totalCount }),
  });
};
